import axios from 'axios';
import store from '@/store';
import router from '@/router';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const discordWebhookUrl = process.env.VUE_APP_ERROR_LOG_DISCORD;

async function sendDiscordNotification(error) {
  if (
    process.env.NODE_ENV === 'development' ||
    error.response?.status === 401 ||
    error.config?.url === discordWebhookUrl
  ) return;

  const message = {
    username: "Error Monitor",
    embeds: [
      {
        title: "🚨 Novo Request Error Detectado!",
        description: `**Erro:** ${error.message || "Erro não especificado"}`,
        color: 16711680,
        fields: [
          { name: "BASE_URL", value: error.config?.baseURL || "Desconhecido" },
          { name: "URL", value: error.config?.url || "Desconhecido" },
          { name: "Método", value: error.config?.method?.toUpperCase() || "Desconhecido", inline: true },
          { name: "Status", value: `${error.response?.status || "Desconhecido"}`, inline: true },
          {
            name: "Headers",
            value: `\`\`\`${JSON.stringify(error.config?.headers || {}, null, 2).slice(0, 1000)}\`\`\``,
          },
          {
            name: "Data",
            value: `\`\`\`${JSON.stringify(error.config?.data || {}, null, 2).slice(0, 1000)}\`\`\``,
          },
          {
            name: "Response Data",
            value: `\`\`\`${JSON.stringify(error.response?.data || {}, null, 2).slice(0, 1000)}\`\`\``,
          },
          {
            name: "Stack",
            value: `\`\`\`${(error.stack || "").toString().slice(0, 1000)}\`\`\``,
          },
        ],
        timestamp: new Date().toISOString(),
      },
    ],
  };

  try {
    await api.post(discordWebhookUrl, message);
  } catch (e) {
    console.error("Erro ao enviar log para o Discord", e);
  }
}

api.interceptors.response.use(
  response => response,
  async error => {
    if (error.response?.status === 401) {
      store.dispatch('auth/logout');
      if (router.currentRoute.value.name !== 'Login') {
        await router.push({ name: 'Login' });
      }
    }

    await sendDiscordNotification(error);
    return Promise.reject(error);
  }
);

api.interceptors.request.use((config) => {

  if (config.authRequired) {
    const token = store.state.auth.token

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  return config;
}, (error) => Promise.reject(error));

export default api;
